import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-form-negoziazione-assistita-view',
  templateUrl: './form-negoziazione-assistita-view.component.html',
  styleUrls: ['./form-negoziazione-assistita-view.component.css']
})
export class FormNegoziazioneAssistitaViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
